const FILE_TYPE_ENUM = {
  INVOICE: "invoice",
  RODO: "rodo",
};

export { FILE_TYPE_ENUM };
